import {
    appReducer,
    loggedInReducer,
    editArticleModalReducer,
    removeArticleModalReducer,
    editClassesModalReducer
} from './clickReducers';

import {combineReducers} from 'redux';
import {
    editModalReducer,
    publishArticleModalReducer,
    multimediaModalReducer,
    addFilesModalReducer
} from "../pages/modals/reducer";
import {approveArticlesReducer} from "../pages/news/approve/reducer";
import {manageArticlesReducer} from "../pages/news/manage/reducer";
import {multimediaReducer} from "../pages/multimedia/reducer";
import {dashboardReducer} from '../pages/dashboard/reducer';
import {presentationReducer} from "../pages/presentation/reducer";
import {classesReducer} from "../pages/classes/reducer";
import {createNewArticlesReducer} from "../pages/news/create/article/reducer";
import {RESET_REDUX_STATES} from "../actions/actionTypes";
import {loginReducer} from "../pages/authentication/reducer";

export const Reducers = combineReducers({
    appReducer,
    loginReducer,
    loggedInReducer,
    dashboardReducer,
    manageArticlesReducer,
    approveArticlesReducer,
    editArticleModalReducer,
    publishArticleModalReducer,
    removeArticleModalReducer,
    classesReducer,
    editClassesModalReducer,
    presentationReducer,
    editModalReducer,
    multimediaReducer,
    multimediaModalReducer,
    addFilesModalReducer,
    createNewArticlesReducer
});

export const rootReducer = (state, action) => {
    if (action.type === RESET_REDUX_STATES) {
        state = undefined
    }

    return Reducers(state, action)
};